import React from "react";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import { txtA } from "../../../Label/Lbl";

function NewUnderCom(props) {

    const { sta, inv, locInv } = props;
    const styleNameA = { fontWeight: "bold", textAlign: "right", fontSize: "1.2rem" };
    const styleNameE = { fontWeight: "bold", textAlign: "left", fontSize: "1.2rem" };
    const styfCenter = { fontWeight: "bold", maxHeight: "1rem", minHeight: "1rem", color: "#000", textAlign: "center", };
    const styLeft = { textAlign: "left", paddingLeft: "0.5rem", maxLines: 1, };
    const styLeft2 = { textAlign: "left", paddingLeft: "0.5rem", maxLines: 1, fontWeight: "bold", fontSize: "1rem" };
    const styRight = { textAlign: "right", paddingRight: "0.5rem", maxLines: 1, };
    const isPurchase=locInv.ProcTypeInvProc === "02" ||locInv.ProcTypeInvProc === "12"||
    locInv.ProcTypeInvProc === "03"?false:true; 
    return (
        <Grid item container
            justifyContent="center"
        >
            <Grid
                container
                item xs={12}
                style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm", direction: "rtl" }}
            >
                <Grid container item xs={6}>
                    <Grid item xs={12} style={styLeft2}>{"Invoice Detail"}</Grid>
                    <Grid item xs={3} style={styRight}>
                        {locInv?.ProcTypeInvProc === "04" ? "رقم الامر" : txtA.invNumr}
                    </Grid>
                    <Grid item xs={6} style={styfCenter}>
                        <div style={styfCenter}>{sta.tot.id}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {locInv?.ProcTypeInvProc === "04" ? "Order No " : "Invoice No "}
                    </Grid>
                    <Grid item xs={3} style={styRight}>
                        {"التاريخ"}
                    </Grid>
                    <Grid item xs={6} style={styfCenter} >
                        <div style={styfCenter}>{moment(sta.tot.date).format("YYYY/MM/DD")}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {"Invoice Date"}
                    </Grid>
                    <Grid item xs={3} style={styRight}>
                        {"تاريخ الاستحاق"}
                    </Grid>
                    <Grid item xs={6} style={styfCenter}>
                        <div style={styfCenter}>
                            {sta.tot?.Due_date === null ? moment(sta.tot.date).format("YYYY/MM/DD") :
                                moment(sta.tot.Due_date).format("YYYY/MM/DD")}
                        </div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {"Date of supply"}
                    </Grid>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6} >
                        <div style={styfCenter}>{sta?.tot?.OrderTypeA}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {"Project Name"}
                    </Grid>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6} >
                        <div style={styfCenter}>{sta?.tot?.po_no}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {": P.O No"}
                    </Grid>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6} >
                        <div style={styfCenter}>{sta?.tot?.OrderTypeE}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {": Vender No"}
                    </Grid>
                </Grid>
                <Grid container item xs={6}>
                    <Grid item xs={12} style={styLeft2}>  {"Customer Detail"} </Grid>
                    <Grid item xs={3} style={styRight}>
                        {isPurchase?txtA.cusNM:"العميل"}
                    </Grid>
                    <Grid item xs={6} styl>
                        <div style={styfCenter}>{sta.tot.pay_type_name}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {isPurchase?"Supplier":"Customer"}
                    </Grid>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6} style={styfCenter}>
                        <div style={styfCenter}>{inv?.cust_id}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {isPurchase?"Supplier Id": "Customer Id"}
                    </Grid>
                    <Grid item xs={9} style={styfCenter}>
                        <div style={styfCenter}>{sta.tot.cust_address ?? ""}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {isPurchase?"Address": "Customer Address"}
                    </Grid>
                    <Grid item xs={9} >
                        <div style={styfCenter}>{sta.tot.cust_mobile ?? ""}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {"Contact No"}
                    </Grid>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6} >
                        <div style={styfCenter}>{sta.tot.tax_no_cust}</div>
                    </Grid>
                    <Grid item xs={3} style={styLeft}>
                        {"VAT No "}
                    </Grid>
                </Grid>
                <Grid container item xs={12}>

                    <Grid item xs={3} style={styleNameA}>
                        {"المطلوب من المكرم/"}
                    </Grid>
                    <Grid item xs={7} style={styleNameA}>
                        {sta.tot.cust_name}
                    </Grid>
                    <Grid item xs={2} style={styleNameE}>
                        {": Messers"}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default NewUnderCom;